<div class="flex flex-col h-full w-full bg-white overflow-hidden">

  <!-- Inhalt: füllt den Platz zwischen Header und Footer; NICHT die ganze Seite scrollen lassen,
       sondern nur die inneren Listen (siehe unten), damit der DSGVO-Footer immer sichtbar bleibt. -->
  <div class="flex flex-col flex-1 min-h-0 overflow-hidden gap-6 p-6">

    <!-- Prüfzusammenfassung: äußere Box mit grauem Header laut Figma. Einklappbar für kleine Screens. -->
    <div class="flex flex-col border border-gray-200 rounded-lg w-full shrink-0">
      <!-- Header: klickbar zum Ein-/Ausklappen -->
      <button (click)="summaryCollapsed = !summaryCollapsed"
              [attr.aria-expanded]="!summaryCollapsed"
              [class.border-b]="!summaryCollapsed"
              [class.border-gray-200]="!summaryCollapsed"
              [class.rounded-b-lg]="summaryCollapsed"
              class="flex flex-row items-center gap-2 px-4 py-3 bg-gray-100 rounded-t-lg text-left w-full hover:bg-gray-200 transition-colors"
              type="button">
        <fa-icon [icon]="faScrewdriverWrench" class="text-sm text-gray-500"></fa-icon>
        <span class="text-sm font-medium text-gray-900">Prüfzusammenfassung</span>
        <fa-icon [class.rotate-180]="!summaryCollapsed"
                 [icon]="faChevronDown"
                 class="text-sm text-gray-500 ml-auto transition-transform"></fa-icon>
      </button>
      <!-- Inhalt -->
      @if (!summaryCollapsed) {
      <div class="flex flex-col gap-4 p-4 bg-white rounded-b-lg">
        @if (plan.checkDescription) {
          <p class="text-sm text-gray-900">{{ plan.checkDescription }}</p>
        }
        <!-- 4 Karten nebeneinander (row, gap-6) laut Figma -->
        <div class="flex flex-row items-stretch gap-6">
          <!-- Allgemein -->
          <div class="flex flex-col flex-1 min-w-0 gap-2 p-4 bg-gray-100 border border-gray-300 rounded-lg">
            <div class="flex flex-row items-center gap-2">
              <fa-icon [icon]="faMemoCircleCheck" class="text-sm text-gray-500"></fa-icon>
              <span class="text-sm font-medium text-gray-900">Allgemein</span>
            </div>
            <span class="text-xs text-gray-500">Auslöser: {{ plan.triggerLabel }}</span>
          </div>
          <!-- Prüfregeln -->
          <div class="flex flex-col flex-1 min-w-0 gap-2 p-4 bg-gray-100 border border-gray-300 rounded-lg">
            <div class="flex flex-row items-center gap-2">
              <fa-icon [icon]="faClipboardList" class="text-sm text-gray-500"></fa-icon>
              <span class="text-sm font-medium text-gray-900">Prüfregeln</span>
            </div>
            <div class="flex flex-col gap-0.5">
              <span class="text-xs text-gray-500">
                {{ isRuleManual ? 'Prüfregelauswahl manuell bei jedem Check' : 'Vordefinierte Prüfregeln' }}
              </span>
              <span class="text-xs text-gray-500">{{ ruleSummaryLine }}</span>
            </div>
          </div>
          <!-- Dateien -->
          <div class="flex flex-col flex-1 min-w-0 gap-2 p-4 bg-gray-100 border border-gray-300 rounded-lg">
            <div class="flex flex-row items-center gap-2">
              <fa-icon [icon]="faFile" class="text-sm text-gray-500"></fa-icon>
              <span class="text-sm font-medium text-gray-900">Dateien</span>
            </div>
            <div class="flex flex-col gap-0.5">
              <span class="text-xs text-gray-500">{{ fileModeSummary }}</span>
              <span class="text-xs text-gray-500">Dateityp: {{ fileTypeSummary }}</span>
              @if (documentClassesLoading && plan.documentClasses?.length) {
                <span class="text-xs text-gray-500 flex flex-row items-center gap-1.5">
                  Dokumenten:
                  <fa-icon [icon]="faSpinnerThird" class="animate-spin text-gray-400"></fa-icon>
                </span>
              } @else if (documentClassChips.length) {
                <div class="flex flex-row items-baseline text-xs text-gray-500 min-w-0">
                  <span class="shrink-0 mr-1">Dokumenten:</span>
                  <div #documentClassTextContainer class="flex flex-row min-w-0 overflow-hidden whitespace-nowrap">
                    @for (title of documentClassChips; track title) {
                      <span class="doc-class-item whitespace-nowrap">{{ title }}</span>
                    }
                  </div>
                  <span class="overflow-counter doc-class-item shrink-0" style="display:none">+0</span>
                </div>
              } @else {
                <span class="text-xs text-gray-500">Dokumenten: {{ documentClassSummary }}</span>
              }
            </div>
          </div>
          <!-- Bericht -->
          <div class="flex flex-col flex-1 min-w-0 gap-2 p-4 bg-gray-100 border border-gray-300 rounded-lg">
            <div class="flex flex-row items-center gap-2">
              <fa-icon [icon]="faMemoCircleCheck" class="text-sm text-gray-500"></fa-icon>
              <span class="text-sm font-medium text-gray-900">Bericht</span>
            </div>
            <div class="flex flex-col gap-0.5">
              <span class="text-xs text-gray-500">Aufbau: {{ reportPerspectiveLabel }}</span>
              <span class="text-xs text-gray-500">Berichtsformate: {{ reportFormatsLabel }}</span>
            </div>
          </div>
        </div>
      </div>
      }
    </div>

    <!-- Auswahl: Regeln + Dateien nebeneinander. flex-1 + min-h-0 statt fixem h-[600px],
         damit die Kacheln den Restplatz füllen und nur intern scrollen. -->
    <div class="flex flex-col flex-1 min-h-0 main-xl:flex-row items-stretch gap-6 w-full">

      <!-- ── Prüfregeln ─────────────────────────────────────────────────── -->
      <div class="flex flex-col flex-1 min-w-0 min-h-0 border border-gray-200 rounded-lg overflow-hidden">
        <div class="flex flex-row items-center gap-2 px-4 py-3 bg-gray-50 border-b border-gray-200 rounded-t-lg">
          <fa-icon [icon]="faClipboardList" class="text-sm text-gray-500"></fa-icon>
          <span class="text-sm font-medium text-gray-900">
            {{ isRuleManual ? 'Prüfregeln' : 'Ausgewählte Prüfregeln' }}
          </span>
          @if (!isRuleManual) {
            <span class="text-xs text-gray-500 ml-2">
              Die Prüfregeln wurden vorausgewählt und können in den Einstellungen konfiguriert werden.
            </span>
          }
        </div>

        <div class="flex flex-col gap-4 p-4 flex-1 min-h-0">

          @if (rulesLoading) {
            <div class="flex flex-col gap-2">
              @for (i of [1, 2, 3, 4]; track i) {
                <div class="h-10 rounded-lg bg-gray-100 animate-pulse"></div>
              }
            </div>
          } @else if (isRuleManual) {
            <!-- MANUELL: interaktive Regelauswahl. Header-Block (Zusammenfassung + Suche/Button) in
                 gap-3 gruppiert, analog zur "Controls"-Struktur von bic-file-manager (compactSelectionView),
                 damit die Listen beider Kacheln auf derselben Höhe beginnen. -->
            <div class="flex flex-col gap-3 w-full shrink-0">
              <div class="flex flex-row items-center justify-between gap-2">
                <span class="text-sm font-medium text-gray-900">
                  {{ totalAvailableRules }} Verfügbare Prüfregeln aus {{ ruleGroups.length }} myChecks
                </span>
                <span class="text-sm text-gray-500">{{ totalSelectedRules }} von {{ totalAvailableRules }} ausgewählt</span>
              </div>

              <div class="flex flex-row items-center gap-3">
                <div class="flex-1 min-w-0">
                  <bic-input (valueChange)="ruleSearch = $event"
                             [iconStart]="faSearch"
                             [placeholder]="'Suche nach...'"
                             [value]="ruleSearch">
                  </bic-input>
                </div>
                <bic-button (click)="selectAllRules()" buttonType="white">Alle auswählen</bic-button>
              </div>
            </div>

            <div class="flex flex-col gap-2 flex-1 min-h-0 overflow-y-auto">
              @for (group of filteredRuleGroups; track group.ruleset.id) {
                <div class="flex flex-col border border-gray-200 rounded-lg">
                  <!-- Set-Kopfzeile -->
                  <div class="flex flex-row items-center gap-3 px-4 py-2 min-h-[40px]">
                    <button (click)="toggleExpand(group)"
                            class="flex items-center justify-center w-4 h-6 shrink-0 text-gray-500 hover:text-gray-900"
                            type="button">
                      <fa-icon [icon]="faChevronDown"
                               [class.rotate-180]="isExpanded(group)"
                               class="text-xs transition-transform"></fa-icon>
                    </button>
                    <button (click)="toggleSet(group)" class="flex items-center gap-3 flex-1 min-w-0 text-left"
                            type="button">
                      <span
                        [class]="isSetSelected(group) || isSetPartiallySelected(group) ? 'bg-green border-green text-white' : 'bg-gray-50 border-gray-300'"
                        class="flex items-center justify-center w-4 h-4 rounded border shrink-0">
                        @if (isSetSelected(group)) {
                          <fa-icon [icon]="faCheck" class="text-[10px]"></fa-icon>
                        } @else if (isSetPartiallySelected(group)) {
                          <fa-icon [icon]="faMinus" class="text-[10px]"></fa-icon>
                        }
                      </span>
                      <span class="text-sm text-gray-900 truncate">{{ group.ruleset.name }}</span>
                    </button>
                    <span class="text-xs text-gray-500 whitespace-nowrap shrink-0">
                      {{ effectiveRuleCount(group) <= 1 ? '1 Regel' : effectiveRuleCount(group) + ' Regeln' }}
                    </span>
                    <span
                      [class]="'text-xs font-medium px-2.5 py-0.5 rounded-md shrink-0 ' + getTypeBadgeClass(group.ruleset.type)">
                      {{ getTypeBadgeLabel(group.ruleset.type) }}
                    </span>
                  </div>

                  <!-- Einzelregeln -->
                  @if (isExpanded(group)) {
                    <div class="flex flex-col">
                      @if (group.loading) {
                        @for (i of [1, 2]; track i) {
                          <div class="h-8 mx-4 my-1 rounded bg-gray-100 animate-pulse"></div>
                        }
                      } @else if (group.rules.length === 0) {
                        <div class="pl-16 pr-4 py-3 text-xs text-gray-500">Keine Einzelregeln verfügbar.</div>
                      } @else {
                        @for (rule of group.rules; track rule.id) {
                          <button (click)="toggleRule(group, rule)"
                                  class="flex flex-row items-center gap-3 pl-16 pr-4 min-h-[40px] text-left hover:bg-gray-50 transition-colors"
                                  type="button">
                            <span
                              [class]="isRuleSelected(group, rule) ? 'bg-green border-green text-white' : 'bg-gray-50 border-gray-300'"
                              class="flex items-center justify-center w-4 h-4 rounded border shrink-0">
                              @if (isRuleSelected(group, rule)) {
                                <fa-icon [icon]="faCheck" class="text-[10px]"></fa-icon>
                              }
                            </span>
                            @if (group.ruleset.type !== 'IDS') {
                              <span
                                class="text-sm font-medium text-gray-900 shrink-0 w-[10ch]">{{ rule.code || '-' }}</span>
                            }
                            <span class="text-sm text-gray-500 truncate">{{ rule.name }}</span>
                          </button>
                        }
                      }
                    </div>
                  }
                </div>
              }
              @if (filteredRuleGroups.length === 0) {
                <div class="text-sm text-gray-500 py-6 text-center">Keine Prüfregeln gefunden.</div>
              }
            </div>
          } @else {
            <!-- VORDEFINIERT: read-only Anzeige nach Figma -->
            <div class="grid grid-cols-2 gap-4">
              <div class="flex flex-col items-center justify-center gap-1 p-4 bg-gray-50 border border-gray-200 rounded-lg">
                <span class="text-base font-medium text-gray-900">{{ ruleGroups.length }}</span>
                <span class="text-xs text-gray-500">myChecks</span>
              </div>
              <div class="flex flex-col items-center justify-center gap-1 p-4 bg-gray-50 border border-gray-200 rounded-lg">
                <span class="text-base font-medium text-gray-900">{{ totalSelectedRules }}</span>
                <span class="text-xs text-gray-500">Prüfregeln</span>
              </div>
            </div>
            <div class="flex flex-col gap-2 flex-1 min-h-0 overflow-y-auto">
              @for (group of filteredRuleGroups; track group.ruleset.id) {
                <!-- Regelset-Karte: p-4, gap-2, border, border-radius — analog zu Dateigruppen -->
                <div class="flex flex-col gap-2 border border-gray-200 rounded-lg p-4">
                  <!-- Regelset-Header -->
                  <div class="flex flex-row items-center gap-2">
                    <span class="text-sm font-medium text-gray-900 flex-1 truncate">{{ group.ruleset.name }}</span>
                    <span class="text-xs text-gray-500 whitespace-nowrap">
                      {{ effectiveRuleCount(group) <= 1 ? '1 Regel' : effectiveRuleCount(group) + ' Regeln' }}
                    </span>
                    <span [class]="'text-xs font-medium px-2.5 py-0.5 rounded-md shrink-0 ' + getTypeBadgeClass(group.ruleset.type)">
                      {{ getTypeBadgeLabel(group.ruleset.type) }}
                    </span>
                  </div>
                  <!-- Einzelregeln: icon + Kürzel (schwarz, 60px) + Name (grau, flex-1) -->
                  @for (rule of group.rules; track rule.id) {
                    <div class="flex flex-row items-center gap-3 pl-4">
                      <div class="flex items-center justify-center w-4 h-4 shrink-0">
                        <fa-icon [icon]="faCircleCheck" class="text-gray-300 text-base"></fa-icon>
                      </div>
                      @if (group.ruleset.type !== 'IDS') {
                        <span class="text-sm font-medium text-gray-900 shrink-0 w-[10ch]">{{ rule.code || '-' }}</span>
                      }
                      <span class="text-sm font-medium text-gray-500 flex-1 truncate">{{ rule.name }}</span>
                    </div>
                  }
                  <div class="flex flex-col gap-0.5 mt-1">
                    <span class="text-xs text-gray-500">
                      Prüfbare Dateiformate: {{ getRulesetFileFormatsLabel(group.ruleset) }}
                    </span>
                    <span class="text-xs text-gray-500">
                      Prüfbare Dokumentenklassen: {{ getRulesetDocumentClassesLabel(group.ruleset) }}
                    </span>
                  </div>
                </div>
              }
            </div>
          }
        </div>
      </div>

      <!-- ── Dateien ────────────────────────────────────────────────────── -->
      <div class="flex flex-col flex-1 min-w-0 min-h-0 border border-gray-200 rounded-lg overflow-hidden">
        <div class="flex flex-row items-center gap-2 px-4 py-3 bg-gray-50 border-b border-gray-200 rounded-t-lg">
          <fa-icon [icon]="faFile" class="text-sm text-gray-500"></fa-icon>
          <span class="text-sm font-medium text-gray-900">
            {{ isFileManual ? 'Dateien' : 'Ausgewählte Dateien' }}
          </span>
          @if (plan.userHint?.trim()) {
            <span class="text-xs text-gray-500">({{ plan.userHint }})</span>
          }
          @if (!isFileManual) {
            <span class="text-xs text-gray-500 ml-2">
              Die Dateien werden anhand der hinterlegten Kriterien automatisch beim Start der Prüfung ermittelt.
            </span>
          }
        </div>

        <div class="flex flex-col gap-4 p-4 flex-1 min-h-0 overflow-y-auto">
          @if (isFileManual) {
            <!-- MANUELL: interaktive Dateiauswahl (kompakter Auswahl-View) -->
            @if (filesLoading) {
              <div class="flex flex-col gap-2">
                @for (i of [1, 2, 3, 4]; track i) {
                  <div class="h-10 rounded-lg bg-gray-100 animate-pulse"></div>
                }
              </div>
            } @else {
              <div class="flex flex-1 min-h-0 overflow-hidden">
                <bic-file-manager
                  [config]="fileManagerConfig"
                  [compactSelectionView]="true"
                  [preserveSelectionOnNavigate]="true"
                  [selectChildrenOnFolderSelect]="true"
                  [customFilesActivated]="true"
                  [customFiles]="displayedBicFiles"
                  [filterConfigs]="fileFilterConfigs"
                  [selectedFiles]="bicSelectedFiles"
                  (selectedFilesChange)="onBicSelectionChange($event)"
                  (input)="onFileManagerSearchInput($event)"
                  [calledFromCheck]="true"
                  [noOuterPadding]="true"
                  class="flex w-full h-full">
                </bic-file-manager>
              </div>
            }
          } @else {
            <!-- VORDEFINIERT: Dateien aus dem Projekt nach Typ gruppiert -->
            @if (filesLoading) {
              <div class="flex flex-col gap-2">
                @for (i of [1, 2, 3, 4]; track i) {
                  <div class="h-10 rounded-lg bg-gray-100 animate-pulse"></div>
                }
              </div>
            } @else {
              <!-- Stat-Karten: Anzahl + Gesamtgröße -->
              <div class="grid grid-cols-2 gap-4">
                <div class="flex flex-col items-center justify-center gap-1 p-4 bg-gray-50 border border-gray-200 rounded-lg">
                  <span class="text-base font-medium text-gray-900">{{ predefinedFiles.length }}</span>
                  <span class="text-xs text-gray-500">Dateien</span>
                </div>
                <div class="flex flex-col items-center justify-center gap-1 p-4 bg-gray-50 border border-gray-200 rounded-lg">
                  <span class="text-base font-medium text-gray-900">{{ formatBytes(totalPredefinedSize) }}</span>
                  <span class="text-xs text-gray-500">Gesamtgröße</span>
                </div>
              </div>

              <!-- Dateien nach Typ gruppiert -->
              @if (groupedPredefinedFiles.length === 0) {
                <p class="text-sm text-gray-500 py-4 text-center">
                  Keine Dateien gefunden. Die Dateien werden anhand der hinterlegten Kriterien beim Start der Prüfung ermittelt.
                </p>
              } @else {
                <div class="flex flex-col gap-3 flex-1 min-h-0 overflow-y-auto">
                  @for (group of groupedPredefinedFiles; track group.fileType) {
                    <!-- Gruppen-Karte: border, border-radius, p-4, gap-2 laut Figma -->
                    <div class="flex flex-col gap-2 border border-gray-200 rounded-lg p-4">
                      <!-- Gruppen-Header: kein Hintergrund, kein Trennstrich -->
                      <div class="flex flex-row items-center gap-2">
                        <span class="text-sm font-medium text-gray-900 flex-1">{{ group.label }}</span>
                        <span class="text-xs text-gray-500 w-[76px] text-right">{{ group.files.length }} {{ group.files.length === 1 ? 'Datei' : 'Dateien' }}</span>
                        <span class="text-xs text-gray-500 w-[76px] text-right">{{ formatBytes(group.totalSize) }}</span>
                      </div>
                      <!-- Datei-Zeilen: pl-4 Einrückung, gap-3 laut Figma -->
                      @for (file of group.files; track file.id) {
                        <div class="flex flex-row items-center gap-3 pl-4">
                          <div class="flex items-center justify-center w-4 h-4 shrink-0">
                            <fa-icon [icon]="getFileIcon(file.fileType)" class="text-gray-400 text-base"></fa-icon>
                          </div>
                          <span class="text-sm text-gray-900 flex-1 truncate">{{ file.name }}</span>
                          <span class="text-xs text-gray-500 whitespace-nowrap">{{ formatBytes(file.size) }}</span>
                        </div>
                      }
                    </div>
                  }
                </div>
              }
            }
          }
        </div>
      </div>
    </div>
  </div>

  <!-- Blocker: Regelset, für das keine der gewählten Dateien passt (jedes Set prüft nur seine
       kompatiblen Formate; ein leerer Teilbericht würde den Bericht vollständig aussehen lassen) -->
  @if (rulesetsWithoutMatchingFile.length > 0) {
    <div class="mx-6 mb-3 flex flex-row items-start gap-2 px-3 py-2 rounded-lg bg-yellow-50 border border-yellow-200 flex-shrink-0">
      <fa-icon [icon]="faCircleInfo" class="text-yellow-800 text-xs mt-0.5 shrink-0"></fa-icon>
      <span class="text-xs text-yellow-800">
        Keine passende Datei ausgewählt für
        <span class="font-medium">{{ rulesetsWithoutMatchingFile.join(', ') }}</span>.
        Bitte passende Dateien wählen oder das myCheck abwählen.
      </span>
    </div>
  }

  <!-- Footer -->
  <div class="flex flex-row items-center justify-between gap-4 pt-0.5 px-6 pb-6 bg-white flex-shrink-0 self-stretch">
    <div class="flex flex-row items-center gap-2">
      <fa-icon [icon]="faShieldCheck" class="text-sm text-gray-700"></fa-icon>
      <span class="text-sm font-medium text-gray-700">DSGVO-konforme &amp; verschlüsselte Datenverarbeitung</span>
    </div>
    <div class="flex flex-row items-center gap-4">
      <bic-button (click)="showConfirmation()" [disabled]="!canStart" [loading]="confirming"
                  [tooltip]="startDisabledReason" tooltipDirection="left">
        <fa-icon [icon]="faPlay" iconLeft></fa-icon>
        Prüfung starten
      </bic-button>
      @if (showConfirmPopup) {
        <bic-popup (close)="showConfirmPopup = false" [hasBackdrop]="true"
                   [title]="'Möchten Sie die Prüfung wirklich ausführen?'" customClass="w-[560px] h-fit">
          <div bicPopupContent class="flex flex-col gap-4 font-normal">
            <p>Bei Bestätigung der Prüfung werden die <span class="font-medium">ausgewählten Prüfregeln</span> mit den
              <span class="font-medium">ausgewählten Dateien</span> ausgeführt.</p>
            <p><span class="text-green font-medium">Hinweis: </span><br>
              Das Ausführen der Prüfung verbraucht
              <span class="font-medium">{{ checkCost }}</span>
              {{ checkCost === 1 ? 'Prüfung' : 'Prüfungen' }} Ihres Kontingents.
              @if (billedRulesetCount > 1) {
                <span class="text-gray-500">({{ billedRulesetCount }} myChecks – jedes myCheck wird als
                  eigene Prüfung ausgeführt und einzeln abgerechnet)</span>
              }
            </p>
            @if (!hasSufficientCredits) {
              <span>
                Leider stehen für diese Prüfung
                <span class="font-medium">nicht genügend Prüfungen</span>
                zur Verfügung.
              </span>
            } @else {
              <span>
                Nach dieser Prüfung bleiben noch <span class="font-medium">{{ checksAfterRun }}</span>
                {{ checksAfterRun === 1 ? 'Prüfung' : 'Prüfungen' }} übrig.
              </span>
            }

            <!-- Optionaler Berichtsname: ohne Eingabe heisst der Bericht wie der myCheck
                 (defaultReportName, siehe start()). Das Feld bleibt deshalb zugeklappt, bis der
                 Nutzer es aktiv aufruft - sonst wirkt es wie ein Pflichtfeld. Nur (valueChange)
                 gebunden, nicht zusaetzlich (input) - bic-input feuert beides, und beide
                 Bindungen zusammen fuehren zu einem doppelten Lauf. -->
            <div class="pt-4 border-t border-gray-200">
              @if (showReportNameInput) {
                <bic-input (valueChange)="reportName = $event"
                           [label]="'Berichtsname (optional)'"
                           [maxLength]="reportNameMaxLength"
                           [placeholder]="defaultReportName"
                           [showX]="true"
                           [value]="reportName">
                </bic-input>
              } @else {
                <button type="button" (click)="showReportNameInput = true"
                        class="flex items-center gap-1.5 text-sm font-medium text-gray-500 hover:text-gray-700 transition-colors">
                  <fa-icon [icon]="faPen" class="text-xs"></fa-icon>
                  Eigenen Berichtsnamen vergeben
                </button>
              }
            </div>
          </div>
          <div bicPopupButtonGroup class="flex flex-row justify-end gap-4">
            <bic-button (onClick)="showConfirmPopup = false" buttonType="white">
              Abbrechen
            </bic-button>
            <bic-button (click)="start()" [disabled]="!hasSufficientCredits" [loading]="confirming">
              Prüfung starten
              @if (!confirming) {
                <fa-icon [icon]="faPlay" iconRight></fa-icon>
              }
            </bic-button>
          </div>
        </bic-popup>
      }
    </div>
  </div>
</div>
